import React from 'react';
import PropTypes from 'prop-types';

const EmptyWidget = ({ emptyText, error }) => (
  <span className={error ? 'no-widget-text error' : 'no-widget-text success'}>
    {emptyText}
  </span>
);

EmptyWidget.propTypes = {
  emptyText: PropTypes.string.isRequired,
};
export default EmptyWidget;
